"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * fixed-save
 * fixed-save-v1
 *
 * The version of the OpenAPI document: v1
 * Contact: support@telenor.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FixedSaveV1Api = exports.FixedSaveV1ApiFactory = exports.FixedSaveV1ApiFp = exports.FixedSaveV1ApiAxiosParamCreator = void 0;
const axios_1 = require("axios");
// Some imports not used depending on template conditions
// @ts-ignore
const common_1 = require("../common");
// @ts-ignore
const base_1 = require("../base");
/**
 * FixedSaveV1Api - axios parameter creator
 * Client library for the fixed save API
 * @export
 */
const FixedSaveV1ApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Get save offers
         * @param {string} subscriptionId SubscriptionId identifying a subscription in Telenor or CDK.
         * @param {string} [xTelenorChannelName]
         * @param {string} [xKurtId]
         * @param {string} [xTelenorDealerSalesRep]
         * @param {string} [xTelenorDealerId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOffers: (subscriptionId_1, xTelenorChannelName_1, xKurtId_1, xTelenorDealerSalesRep_1, xTelenorDealerId_1, ...args_1) => __awaiter(this, [subscriptionId_1, xTelenorChannelName_1, xKurtId_1, xTelenorDealerSalesRep_1, xTelenorDealerId_1, ...args_1], void 0, function* (subscriptionId, xTelenorChannelName, xKurtId, xTelenorDealerSalesRep, xTelenorDealerId, options = {}) {
            // verify required parameter 'subscriptionId' is not null or undefined
            (0, common_1.assertParamExists)('getOffers', 'subscriptionId', subscriptionId);
            const localVarPath = `/v1/subscription/{subscriptionId}/offers`
                .replace(`{${"subscriptionId"}}`, encodeURIComponent(String(subscriptionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication authentication-telenorid-plus required
            // oauth required
            yield (0, common_1.setOAuthToObject)(localVarHeaderParameter, "authentication-telenorid-plus", ["api:fixed-save-v1:offers", "api:fixed-save-v1:mtw-save", "api:fixed-save-v1:oneview"], configuration);
            // authentication authentication-external-user required
            // oauth required
            yield (0, common_1.setOAuthToObject)(localVarHeaderParameter, "authentication-external-user", ["api:fixed-save-v1:offers", "api:fixed-save-v1:mtw-save", "api:fixed-save-v1:oneview"], configuration);
            // authentication authentication-internal-system required
            // oauth required
            yield (0, common_1.setOAuthToObject)(localVarHeaderParameter, "authentication-internal-system", ["api:fixed-save-v1:offers", "api:fixed-save-v1:mtw-save", "api:fixed-save-v1:oneview"], configuration);
            // authentication authentication-client-credentials required
            // oauth required
            yield (0, common_1.setOAuthToObject)(localVarHeaderParameter, "authentication-client-credentials", ["api:fixed-save-v1:offers", "api:fixed-save-v1:mtw-save", "api:fixed-save-v1:oneview"], configuration);
            if (xTelenorChannelName != null) {
                localVarHeaderParameter['x-telenor-channel-name'] = String(xTelenorChannelName);
            }
            if (xKurtId != null) {
                localVarHeaderParameter['X-KurtId'] = String(xKurtId);
            }
            if (xTelenorDealerSalesRep != null) {
                localVarHeaderParameter['x-telenor-dealer-sales-rep'] = String(xTelenorDealerSalesRep);
            }
            if (xTelenorDealerId != null) {
                localVarHeaderParameter['x-telenor-dealer-id'] = String(xTelenorDealerId);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Check if customer has consented to onetime contact after termination
         * @param {string} [xTelenorChannelName]
         * @param {string} [xKurtId]
         * @param {string} [xTelenorDealerSalesRep]
         * @param {string} [xTelenorDealerId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hasConsent: (xTelenorChannelName_1, xKurtId_1, xTelenorDealerSalesRep_1, xTelenorDealerId_1, ...args_1) => __awaiter(this, [xTelenorChannelName_1, xKurtId_1, xTelenorDealerSalesRep_1, xTelenorDealerId_1, ...args_1], void 0, function* (xTelenorChannelName, xKurtId, xTelenorDealerSalesRep, xTelenorDealerId, options = {}) {
            const localVarPath = `/v1/consent`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication authentication-internal-system required
            // oauth required
            yield (0, common_1.setOAuthToObject)(localVarHeaderParameter, "authentication-internal-system", ["api:fixed-save-v1:oneview"], configuration);
            // authentication authentication-client-credentials required
            // oauth required
            yield (0, common_1.setOAuthToObject)(localVarHeaderParameter, "authentication-client-credentials", ["api:fixed-save-v1:oneview"], configuration);
            if (xTelenorChannelName != null) {
                localVarHeaderParameter['x-telenor-channel-name'] = String(xTelenorChannelName);
            }
            if (xKurtId != null) {
                localVarHeaderParameter['X-KurtId'] = String(xKurtId);
            }
            if (xTelenorDealerSalesRep != null) {
                localVarHeaderParameter['x-telenor-dealer-sales-rep'] = String(xTelenorDealerSalesRep);
            }
            if (xTelenorDealerId != null) {
                localVarHeaderParameter['x-telenor-dealer-id'] = String(xTelenorDealerId);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Submit save order
         * @param {ChangeOrder} changeOrder
         * @param {string} [xTelenorChannelName]
         * @param {string} [xKurtId]
         * @param {string} [xTelenorDealerSalesRep]
         * @param {string} [xTelenorDealerId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        order: (changeOrder_1, xTelenorChannelName_1, xKurtId_1, xTelenorDealerSalesRep_1, xTelenorDealerId_1, ...args_1) => __awaiter(this, [changeOrder_1, xTelenorChannelName_1, xKurtId_1, xTelenorDealerSalesRep_1, xTelenorDealerId_1, ...args_1], void 0, function* (changeOrder, xTelenorChannelName, xKurtId, xTelenorDealerSalesRep, xTelenorDealerId, options = {}) {
            // verify required parameter 'changeOrder' is not null or undefined
            (0, common_1.assertParamExists)('order', 'changeOrder', changeOrder);
            const localVarPath = `/v1/order`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication authentication-telenorid-plus required
            // oauth required
            yield (0, common_1.setOAuthToObject)(localVarHeaderParameter, "authentication-telenorid-plus", ["api:fixed-save-v1:order", "api:fixed-save-v1:mtw-save", "api:fixed-save-v1:oneview"], configuration);
            // authentication authentication-external-user required
            // oauth required
            yield (0, common_1.setOAuthToObject)(localVarHeaderParameter, "authentication-external-user", ["api:fixed-save-v1:order", "api:fixed-save-v1:mtw-save", "api:fixed-save-v1:oneview"], configuration);
            // authentication authentication-internal-system required
            // oauth required
            yield (0, common_1.setOAuthToObject)(localVarHeaderParameter, "authentication-internal-system", ["api:fixed-save-v1:order", "api:fixed-save-v1:mtw-save", "api:fixed-save-v1:oneview"], configuration);
            // authentication authentication-client-credentials required
            // oauth required
            yield (0, common_1.setOAuthToObject)(localVarHeaderParameter, "authentication-client-credentials", ["api:fixed-save-v1:order", "api:fixed-save-v1:mtw-save", "api:fixed-save-v1:oneview"], configuration);
            if (xTelenorChannelName != null) {
                localVarHeaderParameter['x-telenor-channel-name'] = String(xTelenorChannelName);
            }
            if (xKurtId != null) {
                localVarHeaderParameter['X-KurtId'] = String(xKurtId);
            }
            if (xTelenorDealerSalesRep != null) {
                localVarHeaderParameter['x-telenor-dealer-sales-rep'] = String(xTelenorDealerSalesRep);
            }
            if (xTelenorDealerId != null) {
                localVarHeaderParameter['x-telenor-dealer-id'] = String(xTelenorDealerId);
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(changeOrder, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Validate save order
         * @param {ChangeOrder} changeOrder
         * @param {string} [xTelenorChannelName]
         * @param {string} [xKurtId]
         * @param {string} [xTelenorDealerSalesRep]
         * @param {string} [xTelenorDealerId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderValidate: (changeOrder_1, xTelenorChannelName_1, xKurtId_1, xTelenorDealerSalesRep_1, xTelenorDealerId_1, ...args_1) => __awaiter(this, [changeOrder_1, xTelenorChannelName_1, xKurtId_1, xTelenorDealerSalesRep_1, xTelenorDealerId_1, ...args_1], void 0, function* (changeOrder, xTelenorChannelName, xKurtId, xTelenorDealerSalesRep, xTelenorDealerId, options = {}) {
            // verify required parameter 'changeOrder' is not null or undefined
            (0, common_1.assertParamExists)('orderValidate', 'changeOrder', changeOrder);
            const localVarPath = `/v1/order/validate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication authentication-telenorid-plus required
            // oauth required
            yield (0, common_1.setOAuthToObject)(localVarHeaderParameter, "authentication-telenorid-plus", ["api:fixed-save-v1:order-validate", "api:fixed-save-v1:mtw-save", "api:fixed-save-v1:oneview"], configuration);
            // authentication authentication-external-user required
            // oauth required
            yield (0, common_1.setOAuthToObject)(localVarHeaderParameter, "authentication-external-user", ["api:fixed-save-v1:order-validate", "api:fixed-save-v1:mtw-save", "api:fixed-save-v1:oneview"], configuration);
            // authentication authentication-internal-system required
            // oauth required
            yield (0, common_1.setOAuthToObject)(localVarHeaderParameter, "authentication-internal-system", ["api:fixed-save-v1:order-validate", "api:fixed-save-v1:mtw-save", "api:fixed-save-v1:oneview"], configuration);
            // authentication authentication-client-credentials required
            // oauth required
            yield (0, common_1.setOAuthToObject)(localVarHeaderParameter, "authentication-client-credentials", ["api:fixed-save-v1:order-validate", "api:fixed-save-v1:mtw-save", "api:fixed-save-v1:oneview"], configuration);
            if (xTelenorChannelName != null) {
                localVarHeaderParameter['x-telenor-channel-name'] = String(xTelenorChannelName);
            }
            if (xKurtId != null) {
                localVarHeaderParameter['X-KurtId'] = String(xKurtId);
            }
            if (xTelenorDealerSalesRep != null) {
                localVarHeaderParameter['x-telenor-dealer-sales-rep'] = String(xTelenorDealerSalesRep);
            }
            if (xTelenorDealerId != null) {
                localVarHeaderParameter['x-telenor-dealer-id'] = String(xTelenorDealerId);
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(changeOrder, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Create or update save consent - Consent to onetime contact with customer, a period after termination
         * @param {string} msisdn MSISDN from the specified country code and local number
         * @param {boolean} withdrawConsent
         * @param {string} [xTelenorChannelName]
         * @param {string} [xKurtId]
         * @param {string} [xTelenorDealerSalesRep]
         * @param {string} [xTelenorDealerId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateConsent: (msisdn_1, withdrawConsent_1, xTelenorChannelName_1, xKurtId_1, xTelenorDealerSalesRep_1, xTelenorDealerId_1, ...args_1) => __awaiter(this, [msisdn_1, withdrawConsent_1, xTelenorChannelName_1, xKurtId_1, xTelenorDealerSalesRep_1, xTelenorDealerId_1, ...args_1], void 0, function* (msisdn, withdrawConsent, xTelenorChannelName, xKurtId, xTelenorDealerSalesRep, xTelenorDealerId, options = {}) {
            // verify required parameter 'msisdn' is not null or undefined
            (0, common_1.assertParamExists)('updateConsent', 'msisdn', msisdn);
            // verify required parameter 'withdrawConsent' is not null or undefined
            (0, common_1.assertParamExists)('updateConsent', 'withdrawConsent', withdrawConsent);
            const localVarPath = `/v1/consent`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication authentication-internal-system required
            // oauth required
            yield (0, common_1.setOAuthToObject)(localVarHeaderParameter, "authentication-internal-system", ["api:fixed-save-v1:oneview"], configuration);
            // authentication authentication-client-credentials required
            // oauth required
            yield (0, common_1.setOAuthToObject)(localVarHeaderParameter, "authentication-client-credentials", ["api:fixed-save-v1:oneview"], configuration);
            if (msisdn !== undefined) {
                localVarQueryParameter['msisdn'] = msisdn;
            }
            if (withdrawConsent !== undefined) {
                localVarQueryParameter['withdrawConsent'] = withdrawConsent;
            }
            if (xTelenorChannelName != null) {
                localVarHeaderParameter['x-telenor-channel-name'] = String(xTelenorChannelName);
            }
            if (xKurtId != null) {
                localVarHeaderParameter['X-KurtId'] = String(xKurtId);
            }
            if (xTelenorDealerSalesRep != null) {
                localVarHeaderParameter['x-telenor-dealer-sales-rep'] = String(xTelenorDealerSalesRep);
            }
            if (xTelenorDealerId != null) {
                localVarHeaderParameter['x-telenor-dealer-id'] = String(xTelenorDealerId);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.FixedSaveV1ApiAxiosParamCreator = FixedSaveV1ApiAxiosParamCreator;
/**
 * FixedSaveV1Api - functional programming interface
 * Client library for the fixed save API
 * @export
 */
const FixedSaveV1ApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.FixedSaveV1ApiAxiosParamCreator)(configuration);
    return {
        /**
         * Get save offers
         * @param {string} subscriptionId SubscriptionId identifying a subscription in Telenor or CDK.
         * @param {string} [xTelenorChannelName]
         * @param {string} [xKurtId]
         * @param {string} [xTelenorDealerSalesRep]
         * @param {string} [xTelenorDealerId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOffers(subscriptionId, xTelenorChannelName, xKurtId, xTelenorDealerSalesRep, xTelenorDealerId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getOffers(subscriptionId, xTelenorChannelName, xKurtId, xTelenorDealerSalesRep, xTelenorDealerId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['FixedSaveV1Api.getOffers']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Check if customer has consented to onetime contact after termination
         * @param {string} [xTelenorChannelName]
         * @param {string} [xKurtId]
         * @param {string} [xTelenorDealerSalesRep]
         * @param {string} [xTelenorDealerId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hasConsent(xTelenorChannelName, xKurtId, xTelenorDealerSalesRep, xTelenorDealerId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.hasConsent(xTelenorChannelName, xKurtId, xTelenorDealerSalesRep, xTelenorDealerId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['FixedSaveV1Api.hasConsent']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Submit save order
         * @param {ChangeOrder} changeOrder
         * @param {string} [xTelenorChannelName]
         * @param {string} [xKurtId]
         * @param {string} [xTelenorDealerSalesRep]
         * @param {string} [xTelenorDealerId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        order(changeOrder, xTelenorChannelName, xKurtId, xTelenorDealerSalesRep, xTelenorDealerId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.order(changeOrder, xTelenorChannelName, xKurtId, xTelenorDealerSalesRep, xTelenorDealerId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['FixedSaveV1Api.order']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Validate save order
         * @param {ChangeOrder} changeOrder
         * @param {string} [xTelenorChannelName]
         * @param {string} [xKurtId]
         * @param {string} [xTelenorDealerSalesRep]
         * @param {string} [xTelenorDealerId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderValidate(changeOrder, xTelenorChannelName, xKurtId, xTelenorDealerSalesRep, xTelenorDealerId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.orderValidate(changeOrder, xTelenorChannelName, xKurtId, xTelenorDealerSalesRep, xTelenorDealerId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['FixedSaveV1Api.orderValidate']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Create or update save consent - Consent to onetime contact with customer, a period after termination
         * @param {string} msisdn MSISDN from the specified country code and local number
         * @param {boolean} withdrawConsent
         * @param {string} [xTelenorChannelName]
         * @param {string} [xKurtId]
         * @param {string} [xTelenorDealerSalesRep]
         * @param {string} [xTelenorDealerId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateConsent(msisdn, withdrawConsent, xTelenorChannelName, xKurtId, xTelenorDealerSalesRep, xTelenorDealerId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updateConsent(msisdn, withdrawConsent, xTelenorChannelName, xKurtId, xTelenorDealerSalesRep, xTelenorDealerId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['FixedSaveV1Api.updateConsent']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
exports.FixedSaveV1ApiFp = FixedSaveV1ApiFp;
/**
 * FixedSaveV1Api - factory interface
 * Client library for the fixed save API
 * @export
 */
const FixedSaveV1ApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.FixedSaveV1ApiFp)(configuration);
    return {
        /**
         * Get save offers
         * @param {FixedSaveV1ApiGetOffersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOffers(requestParameters, options) {
            return localVarFp.getOffers(requestParameters.subscriptionId, requestParameters.xTelenorChannelName, requestParameters.xKurtId, requestParameters.xTelenorDealerSalesRep, requestParameters.xTelenorDealerId, options).then((request) => request(axios, basePath));
        },
        /**
         * Check if customer has consented to onetime contact after termination
         * @param {FixedSaveV1ApiHasConsentRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hasConsent(requestParameters = {}, options) {
            return localVarFp.hasConsent(requestParameters.xTelenorChannelName, requestParameters.xKurtId, requestParameters.xTelenorDealerSalesRep, requestParameters.xTelenorDealerId, options).then((request) => request(axios, basePath));
        },
        /**
         * Submit save order
         * @param {FixedSaveV1ApiOrderRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        order(requestParameters, options) {
            return localVarFp.order(requestParameters.changeOrder, requestParameters.xTelenorChannelName, requestParameters.xKurtId, requestParameters.xTelenorDealerSalesRep, requestParameters.xTelenorDealerId, options).then((request) => request(axios, basePath));
        },
        /**
         * Validate save order
         * @param {FixedSaveV1ApiOrderValidateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderValidate(requestParameters, options) {
            return localVarFp.orderValidate(requestParameters.changeOrder, requestParameters.xTelenorChannelName, requestParameters.xKurtId, requestParameters.xTelenorDealerSalesRep, requestParameters.xTelenorDealerId, options).then((request) => request(axios, basePath));
        },
        /**
         * Create or update save consent - Consent to onetime contact with customer, a period after termination
         * @param {FixedSaveV1ApiUpdateConsentRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateConsent(requestParameters, options) {
            return localVarFp.updateConsent(requestParameters.msisdn, requestParameters.withdrawConsent, requestParameters.xTelenorChannelName, requestParameters.xKurtId, requestParameters.xTelenorDealerSalesRep, requestParameters.xTelenorDealerId, options).then((request) => request(axios, basePath));
        },
    };
};
exports.FixedSaveV1ApiFactory = FixedSaveV1ApiFactory;
/**
 * FixedSaveV1Api - object-oriented interface
 * Client library for the fixed save API
 * @export
 * @class FixedSaveV1Api
 * @extends {BaseAPI}
 */
class FixedSaveV1Api extends base_1.BaseAPI {
    /**
     * Get save offers
     * @param {FixedSaveV1ApiGetOffersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FixedSaveV1Api
     */
    getOffers(requestParameters, options) {
        return (0, exports.FixedSaveV1ApiFp)(this.configuration).getOffers(requestParameters.subscriptionId, requestParameters.xTelenorChannelName, requestParameters.xKurtId, requestParameters.xTelenorDealerSalesRep, requestParameters.xTelenorDealerId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Check if customer has consented to onetime contact after termination
     * @param {FixedSaveV1ApiHasConsentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FixedSaveV1Api
     */
    hasConsent(requestParameters = {}, options) {
        return (0, exports.FixedSaveV1ApiFp)(this.configuration).hasConsent(requestParameters.xTelenorChannelName, requestParameters.xKurtId, requestParameters.xTelenorDealerSalesRep, requestParameters.xTelenorDealerId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Submit save order
     * @param {FixedSaveV1ApiOrderRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FixedSaveV1Api
     */
    order(requestParameters, options) {
        return (0, exports.FixedSaveV1ApiFp)(this.configuration).order(requestParameters.changeOrder, requestParameters.xTelenorChannelName, requestParameters.xKurtId, requestParameters.xTelenorDealerSalesRep, requestParameters.xTelenorDealerId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Validate save order
     * @param {FixedSaveV1ApiOrderValidateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FixedSaveV1Api
     */
    orderValidate(requestParameters, options) {
        return (0, exports.FixedSaveV1ApiFp)(this.configuration).orderValidate(requestParameters.changeOrder, requestParameters.xTelenorChannelName, requestParameters.xKurtId, requestParameters.xTelenorDealerSalesRep, requestParameters.xTelenorDealerId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Create or update save consent - Consent to onetime contact with customer, a period after termination
     * @param {FixedSaveV1ApiUpdateConsentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FixedSaveV1Api
     */
    updateConsent(requestParameters, options) {
        return (0, exports.FixedSaveV1ApiFp)(this.configuration).updateConsent(requestParameters.msisdn, requestParameters.withdrawConsent, requestParameters.xTelenorChannelName, requestParameters.xKurtId, requestParameters.xTelenorDealerSalesRep, requestParameters.xTelenorDealerId, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.FixedSaveV1Api = FixedSaveV1Api;
